/**
 * deriveHealthForPolicies.js — Batch derivation of policy health for list views.
 * Reuses validatePolicy + derivePolicyHealth. Pure, no React.
 * Returns a map policyId -> { status, issueCount } for policies that can be validated.
 * Legacy/unparseable policies are omitted from the map (no badge).
 */

import { parsePolicyDefinition, validatePolicy } from "./policyBuilderState";
import { derivePolicyHealth } from "./derivePolicyHealth";

/**
 * @param {object[]} policies - Policy objects from list API (each has id, policy_json)
 * @returns {Map<string, { status: 'ok'|'warn', issueCount: number }>}
 */
export function deriveHealthForPolicies(policies) {
  const map = new Map();
  if (!Array.isArray(policies)) return map;

  for (const policy of policies) {
    const id = policy?.id ?? policy?.ID;
    if (id == null) continue;

    const raw = policy?.policy_json ?? policy?.policyJson ?? {};
    const parsed = parsePolicyDefinition(raw);
    if (!parsed?.ok || parsed.isLegacy || !parsed.definition?.tiers?.length) {
      continue;
    }

    const metadata = {
      name: policy?.name ?? parsed.metadata?.name ?? "",
      object_type: policy?.object_type ?? parsed.metadata?.object_type ?? "",
      ...parsed.metadata,
    };
    const validation = validatePolicy(metadata, parsed.definition, false);
    const health = derivePolicyHealth(validation, parsed.definition.tiers);

    map.set(String(id), {
      status: health.status,
      issueCount: health.issueCount ?? 0,
    });
  }

  return map;
}
